import 'babel-polyfill';
import 'url-search-params-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import { I18nextProvider } from 'react-i18next';

import './moment/en-gb';
import './moment/ru';
import './moment/fr';
import './moment/de';
import './moment/pt';

import { store, history } from './store/store';
import routes from './store/router';
import i18n from './i18n';

require('./vendor/daterangepicker');
require('select2/dist/js/select2.full');

ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <div>
        <Router history={history}>{routes}</Router>
      </div>
    </I18nextProvider>
  </Provider>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js